import React, { useEffect } from "react";
import { Check } from "../../lib/icons";

const Toast = ({ message, onDone, duration = 2200 }) => {
  useEffect(() => {
    if (!message) return undefined;
    const timer = setTimeout(onDone, duration);
    return () => clearTimeout(timer);
  }, [message, onDone, duration]);

  if (!message) return null;
  return (
    <div className="toast" role="status">
      <Check size={15} />
      {message}
    </div>
  );
};

export default Toast;
